import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { SCHEDULE_API_ROUTES } from "../utils/scheduleApiRoutes";
import { buildApiError, parseJson } from "./apiHelpers";

export async function getScheduleDashboard({ scope = "self" } = {}) {
  const params = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  const res = await authFetch(`${SCHEDULE_API_ROUTES.schedules}/dashboard${params}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to load schedule dashboard");
  return data;
}
